export default /* html */ `
<div class="product-wrapper inner-wrapper">
          <div class="spinner-wrapper">
            <div class="spinner"></div>
          </div>
          <h3 class="product-page-title"></h3>
            <div class="product-tab">
              <p class="total-count">총 <span class="count"></span>건</p>
              <ul class="sort-tab">
                <li class="selected"><button>최신순</button></li>
                <li><button>높은 가격순</button></li>
                <li><button>낮은 가격순</button></li>
                <li><button>할인율순</button></li>
              </ul>
            </div>
            <ul class="product-list"></ul>
          </div>
</div>`;
